module.exports = __webpack_public_path__ + "resources/img/img_dvision2.69ecabe743192f56f0bb4659f901e6e2.png";